import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getAllPeymentGatewaysLoading: false,
  getAllPeymentGatewaysFailed: false,
  getAllPeymentGatewaysReject: false,
  getAllPeymentGatewaysMessage: [],
  AllPeymentGateways: [],

  getPaymentRedirectLoading: false,
  getPaymentRedirectFailed: false,
  getPaymentRedirectReject: false,
  getPaymentRedirectMessage: [],
  PaymentRedirect: [],

  paymentRequestLoading: false,
  paymentRequestFailed: false,
  paymentRequestReject: false,
  paymentRequestMessage: [],
  paymentRequestRedirect: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_PAYMENT_GATEWAYS_LOADING: {
      return {
        ...state,
        getAllPeymentGatewaysLoading: true,
        getAllPeymentGatewaysFailed: false,
        getAllPeymentGatewaysReject: false,
        getAllPeymentGatewaysMessage: [],
        AllPeymentGateways: [],
      };
    }
    case actionTypes.GET_ALL_PAYMENT_GATEWAYS_SUCCESS: {
      return {
        ...state,
        getAllPeymentGatewaysLoading: false,
        getAllPeymentGatewaysFailed: false,
        getAllPeymentGatewaysReject: false,
        getAllPeymentGatewaysMessage: [],
        AllPeymentGateways: action.payload,
      };
    }
    case actionTypes.GET_ALL_PAYMENT_GATEWAYS_FAILED: {
      return {
        ...state,
        getAllPeymentGatewaysLoading: false,
        getAllPeymentGatewaysFailed: true,
        getAllPeymentGatewaysReject: false,
        getAllPeymentGatewaysMessage: [],
        AllPeymentGateways: [],
      };
    }
    case actionTypes.GET_ALL_PAYMENT_GATEWAYS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getAllPeymentGatewaysLoading: false,
        getAllPeymentGatewaysFailed: false,
        getAllPeymentGatewaysReject: true,
        getAllPeymentGatewaysMessage: message,
        AllPeymentGateways: [],
      };
    }

    case actionTypes.GET_PAYMENT_REDIRECT_LOADING: {
      return {
        ...state,
        getPaymentRedirectLoading: true,
        getPaymentRedirectFailed: false,
        getPaymentRedirectReject: false,
        getPaymentRedirectMessage: [],
        PaymentRedirect: [],
      };
    }
    case actionTypes.GET_PAYMENT_REDIRECT_SUCCESS: {
      return {
        ...state,
        getPaymentRedirectLoading: false,
        getPaymentRedirectFailed: false,
        getPaymentRedirectReject: false,
        getPaymentRedirectMessage: [],
        PaymentRedirect: action.payload,
      };
    }
    case actionTypes.GET_PAYMENT_REDIRECT_FAILED: {
      return {
        ...state,
        getPaymentRedirectLoading: false,
        getPaymentRedirectFailed: true,
        getPaymentRedirectReject: false,
        getPaymentRedirectMessage: [],
        PaymentRedirect: [],
      };
    }
    case actionTypes.GET_PAYMENT_REDIRECT_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getPaymentRedirectLoading: false,
        getPaymentRedirectFailed: false,
        getPaymentRedirectReject: true,
        getPaymentRedirectMessage: message,
        PaymentRedirect: [],
      };
    }

    case actionTypes.PAYMENT_REQUEST_LOADING: {
      return {
        ...state,
        paymentRequestLoading: true,
        paymentRequestFailed: false,
        paymentRequestReject: false,
        paymentRequestMessage: [],
        paymentRequestRedirect: '',
      };
    }
    case actionTypes.PAYMENT_REQUEST_SUCCESS: {
      return {
        ...state,
        paymentRequestLoading: false,
        paymentRequestFailed: false,
        paymentRequestReject: false,
        paymentRequestMessage: [],
        paymentRequestRedirect: action.payload.redirectUrl,
      };
    }
    case actionTypes.PAYMENT_REQUEST_FAILED: {
      return {
        ...state,
        paymentRequestLoading: false,
        paymentRequestFailed: true,
        paymentRequestReject: false,
        paymentRequestMessage: [],
        paymentRequestRedirect: '',
      };
    }
    case actionTypes.PAYMENT_REQUEST_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        paymentRequestLoading: false,
        paymentRequestFailed: false,
        paymentRequestReject: true,
        paymentRequestMessage: message,
        paymentRequestRedirect: '',
      };
    }

    default:
      return state;
  }
};
